import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box, Flex } from 'rebass';

import { FONT_SIZE } from '../../../Components/Theme';
import { Text } from '../../../Components/Base';

const NoResultView = () => (
  <Flex flexDirection={'column'} alignItems={'center'} mt={4}>
    <Box mb={4} style={{ textAlign: 'center' }}>
      <img src="/images/redeem_empty.svg" />
      <Text color="greyscale.grey3" fontSize={FONT_SIZE.semilarge}>
        ยังไม่มีข้อมูลผลการสอบ
      </Text>
    </Box>
  </Flex>
);

export default NoResultView;
